import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const INVESTORS = [
  { initials: 'MR', name: 'Marco Rossi', amount: '€31,000', profit: '×4', color: 'text-lime-400' },
  { initials: 'EP', name: 'Elena Petrova', amount: '€26,000', profit: '×3', color: 'text-emerald-400' },
  { initials: 'HM', name: 'Hans Mueller', amount: '€21,100', profit: '×2', color: 'text-green-400' },
  { initials: 'SA', name: 'Sofia Andersen', amount: '€31,000', profit: '×4', color: 'text-lime-400' },
  { initials: 'LB', name: 'Luca Bianchi', amount: '€26,000', profit: '×3', color: 'text-emerald-400' },
];

const TOASTS = [
  { initials: 'PW', name: 'Piotr Wiśniewski', amount: '€21,100', profit: '×2', color: 'text-green-400' },
  { initials: 'SA', name: 'Sofia Andersen', amount: '€26,000', profit: '×3', color: 'text-emerald-400' },
  { initials: 'SC', name: 'Simone Cattaneo', amount: '€31,000', profit: '×4', color: 'text-lime-400' },
];

export default function Activity() {
  const { t } = useTranslation();
  const [toastIdx, setToastIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setToastIdx((p) => (p + 1) % TOASTS.length), 3500);
    return () => clearInterval(interval);
  }, []);

  const inv = TOASTS[toastIdx];

  return (
    <section id="activity" className="py-16 md:py-28 bg-[#0d1117] relative">
      <div className="fixed bottom-6 left-4 z-50 pointer-events-none">
        <div className="pointer-events-auto flex items-center gap-3 rounded-2xl p-3 pr-4 bg-[#0f1f0f]/95 backdrop-blur-md border border-green-500/40 relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-to-b from-green-400 to-green-600 rounded-l-2xl"></div>
          <div className="pl-1 flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-green-900/60 border border-green-600/50 flex items-center justify-center text-white font-bold text-xs">{inv.initials}</div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 mb-0.5">
              <span className="text-white font-semibold text-sm truncate leading-tight">{inv.name}</span>
              <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse flex-shrink-0"></span>
            </div>
            <div className="text-white/55 text-xs">{t('toast_invested')} <span className="text-green-300 font-semibold">{inv.amount}</span></div>
            <div className="text-xs mt-0.5">{t('toast_earned')} <span className={`font-black text-sm ${inv.color}`}>{inv.profit}</span></div>
          </div>
          <div className="w-7 h-7 flex items-center justify-center rounded-full bg-green-500/15 flex-shrink-0">
            <i className="ri-arrow-up-line text-green-400 text-base"></i>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-12 items-center">
          <div className="w-full lg:w-96 flex-shrink-0">
            <div className="bg-[#141a14] border border-green-900/40 rounded-2xl overflow-hidden">
              <div className="flex items-center gap-2 px-5 py-4 border-b border-green-900/30">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                <span className="text-white font-semibold text-sm">{t('act_live_title')}</span>
                <span className="ml-auto bg-green-500/20 text-green-400 text-[10px] font-bold px-2 py-0.5 rounded-full">LIVE</span>
              </div>
              <div className="p-3 space-y-2">
                {INVESTORS.map((investor) => (
                  <div key={investor.name} className="flex items-center gap-3 bg-[#1a2a1a] border border-green-500/20 rounded-xl p-3 relative overflow-hidden">
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-green-500 rounded-l-xl"></div>
                    <div className="pl-1">
                      <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs bg-green-900/70 border border-green-700/50">{investor.initials}</div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-white font-semibold text-xs truncate">{investor.name}</div>
                      <div className="text-white/50 text-[11px] mt-0.5">{t('act_invested')} <span className="text-green-400 font-bold">{investor.amount}</span></div>
                      <div className="text-[11px] mt-0.5">{t('act_earned')} <span className={`font-black ${investor.color}`}>{investor.profit}</span></div>
                    </div>
                    <div className="flex flex-col items-center gap-0.5 flex-shrink-0">
                      <i className="ri-arrow-up-line text-green-400 text-sm"></i>
                      <span className="text-white/20 text-[9px]">{t('act_now')}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-4 py-3 border-t border-green-900/30 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></span>
                <p className="text-white/30 text-[11px]">{t('act_live_note')}</p>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 bg-green-500/10 border border-green-500/20 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-group-line text-green-400 text-sm"></i>
              <span className="text-green-400 text-xs font-semibold uppercase tracking-wide">{t('act_badge')}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-black text-white mb-6">
              {t('act_title_1')}<br /><span className="text-yellow-400">{t('act_title_2')}</span>
            </h2>
            <p className="text-white/60 text-sm md:text-base lg:text-lg leading-relaxed mb-8 max-w-lg">{t('act_desc')}</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4 mb-8">
              {(['1','2','3'] as const).map((n) => (
                <div key={n} className="bg-white/5 border border-white/10 rounded-xl p-3 md:p-4">
                  <div className="text-yellow-400 font-black text-xl md:text-2xl">{t(`act_stat${n}_val`)}</div>
                  <div className="text-white/50 text-xs mt-1">{t(`act_stat${n}_label`)}</div>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <button className="flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-bold px-6 md:px-7 py-3 md:py-3.5 rounded-full transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-user-add-line"></i><span>{t('act_join')}</span>
              </button>
              <button onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
                className="flex items-center gap-2 border border-white/20 text-white/70 hover:text-white hover:border-white/40 font-semibold px-6 md:px-7 py-3 md:py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-eye-line"></i><span>{t('act_view')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
